import React from 'react';
import PropTypes from 'prop-types';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';

import { map, isEmpty, find, isEqual, filter, cloneDeep } from 'lodash';

import { Bert } from 'meteor/themeteorchef:bert';
import uuid from 'uuid/v1';
import {
  Box,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  OutlinedInput,
  Chip,
  Alert,
  Button
} from '@mui/material';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';
import PageHeader from '../../atoms/PageHeader';

import Loading from '../../components/Loading';
import Videos from '../../../api/Videos/Videos';
import Projects from '../../../api/Projects/Projects';
import Profiles from '../../../api/Profiles/Profiles';
import * as profileOps from '../../../api/Profiles/profiles-operations';

import ViewVideosProfiles from '../ViewVideosProfiles/index';

const NewVideosProfiles = ({ loading, allVideos, projectList, profiles, match, history }) => {
  if (loading) return <Loading />;
  const [videosToShow, setVideosToShow] = React.useState(allVideos);
  const [profilesToShow, setProfilesToShow] = React.useState([]);
  const [listEntWine, setListEntWine] = React.useState([]);
  const [clasifyProfile, setClasifyProfile] = React.useState([]);
  const [loadProfile, setLoadProfile] = React.useState(false);

  const [selectProject, setSelectProject] = React.useState('All');
  const [selectVideo, setSelectVideo] = React.useState('none');
  const [selectEntWine, setSelectEntWine] = React.useState('none');
  const [selectBuffer, setSelectBuffer] = React.useState('2.00');
  const [nameProfile, setNameProfile] = React.useState('');
  const [selectClasifyValue, setSelectClasifyValue] = React.useState([]);
  const [selectClasifyNumbers, setSelectClasifyNumbers] = React.useState([]);
  const [newProfileId, setNewProfileId] = React.useState('');
  const [profileSelect, setProfileSelect] = React.useState();
  const [isProfileExist, setIsProfileExist] = React.useState(false);

  const URL_LIST_ENTWINE =
    'https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/list_files_folders';
  const URL_POINTCLOUD = 'https://sd1.ipsgeoprocesing.ipsilum.com/MG/lidar/exec_get_pointcloud';
  const URL_PROCESS = 'https://sd1.ipsgeoprocesing.ipsilum.com/MG/lidar/exec_process_files';
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MultipleSelectProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const submitProfiles = async profile => {
    let newId = '';
    try {
      newId = await methodPromise('profiles.insert', profile);
    } catch (error) {
      handleErrorInClient(error);
      Bert.alert('There was an error creating the profile', 'danger');
    }
    return newId;
  };

  const updateProfiles = async (newSaveProfile, url) => {
    const updateProfile = cloneDeep(newSaveProfile);
    updateProfile.geoJSON.properties.path = url;
    let updateId = '';
    try {
      updateId = await methodPromise('profiles.update', updateProfile);
      setLoadProfile(false);
      Bert.alert('Profile has been successfully generated', 'success');
    } catch (error) {
      setLoadProfile(false);
      handleErrorInClient(error);
      Bert.alert('There was an error saving path of the profile', 'danger');
    }
    return updateId;
  };

  const callToBackEntWine = async () => {
    try {
      const response = await fetch(URL_LIST_ENTWINE, {
        method: 'POST',
        body: JSON.stringify({
          path: '/home/data3/master_folder/lidar/sources',
          beyond_this_folder: null,
          only_folders: 'True',
          only_files: null,
          filter_type_file: null
        }),
        headers: { 'Content-Type': 'application/json' }
      });
      const responseJson = await response.json();
      const dataResponse = responseJson.data;
      setListEntWine(dataResponse);
    } catch (error) {
      Bert.alert('The download entwine for profile has failed', 'danger');
    }
  };

  const loadClasifyPointsProfile = async () => {
    try {
      const response = await fetch(URL_POINTCLOUD, {
        method: 'POST',
        body: JSON.stringify({
          point: 'FirstRequest'
        }),
        headers: { 'Content-Type': 'application/json' }
      });
      const responseJson = await response.json();
      const dataResponse = responseJson.data;
      setClasifyProfile(dataResponse);
    } catch (error) {
      Bert.alert('The download clasify entwine for profile has failed', 'danger');
    }
  };

  const generateProfile = async newSaveProfile => {
    const { coordinates } = selectVideo.track.geometry;
    const { _id } = selectVideo;
    const { path } = selectEntWine;
    const bufferFloat = parseFloat(selectBuffer);
    const profileId = profileOps.getId(newSaveProfile);
    try {
      const response = await fetch(URL_POINTCLOUD, {
        method: 'POST',
        body: JSON.stringify({
          coordSystem: ['EPSG:4326'],
          entwine: path,
          buffer: bufferFloat,
          clasif_number: selectClasifyNumbers,
          guid: profileId,
          point: {
            type: 'LineString',
            coordinates
          },
          id: _id
        }),
        headers: { 'Content-Type': 'application/json' }
      });
      const responseJson = await response.json();
      if (responseJson.status === 'OK' && !isEmpty(responseJson.data)) {
        const newId = await updateProfiles(newSaveProfile, responseJson.data);
        setNewProfileId(newId);
      }
    } catch (error) {
      setLoadProfile(false);
      Bert.alert('There has been a problem downloading the profile', 'danger');
    }
  };

  const checkProcessProfile = async newSaveProfile => {
    const { _id } = newSaveProfile;
    try {
      const response = await fetch(URL_PROCESS, {
        method: 'POST',
        body: JSON.stringify({
          execName: 'Status Processes',
          guid: _id
        }),
        headers: { 'Content-Type': 'application/json' }
      });
      const responseJson = await response.json();
      if (responseJson.status === 'OK' && isEmpty(responseJson.data)) {
        generateProfile(newSaveProfile);
      } else if (responseJson.status === 'OK' && !isEmpty(responseJson.data)) {
        const objectAnswer = responseJson.data[_id];
        if (objectAnswer.status === 'COMPLETED') {
          if (isEqual(profileOps.getPath(newSaveProfile), objectAnswer.link)) {
            setProfileSelect(newSaveProfile);
            setIsProfileExist(true);
          } else {
            updateProfiles(newSaveProfile, objectAnswer.link);
            setProfileSelect(newSaveProfile);
            Bert.alert('The url has been updated', 'success');
          }
        }
        if (objectAnswer.status === 'IN PROCESS') {
          Bert.alert('The profile is in process, try again later.', 'warning');
        }
        setLoadProfile(false);
      } else {
        setLoadProfile(false);
        Bert.alert('There has been a problem processing the profile', 'danger');
      }
    } catch (error) {
      setLoadProfile(false);
      Bert.alert('There has been a problem downloading the profile', 'danger');
    }
  };

  const checkProfileBBDD = async () => {
    if (selectVideo === 'none') {
      Bert.alert('Video not selected', 'danger');
    } else if (selectEntWine === 'none') {
      Bert.alert('Entwine not selected', 'danger');
    } else if (isEmpty(nameProfile)) {
      Bert.alert('Name os profile is empty', 'danger');
    } else {
      const profileExisting = filter(profiles, profile => {
        return (
          isEqual(profileOps.getVideoId(profile), selectVideo._id) &&
          isEqual(profileOps.getBuffer(profile), selectBuffer) &&
          isEqual(profileOps.getEntWineName(profile), selectEntWine.name) &&
          isEqual(profileOps.getClasify(profile), selectClasifyValue)
        );
      });
      if (isEmpty(profileExisting)) {
        const newSaveProfile = {
          name: nameProfile,
          geoJSON: {
            properties: {
              entWineName: selectEntWine.name,
              buffer: selectBuffer,
              path: 'update',
              clasify: selectClasifyValue,
              videoId: selectVideo._id
            }
          }
        };
        const profileId = await submitProfiles(newSaveProfile);
        if (!isEmpty(profileId)) {
          newSaveProfile._id = profileId;
          await checkProcessProfile(newSaveProfile);
        }
      } else {
        await checkProcessProfile(profileExisting[0]);
      }
    }
  };

  const handleCasifyProfile = value => {
    const clasifyNumbers = map(value, element => {
      const object = find(clasifyProfile, ['name', element]);
      return Number(object.number);
    });
    setSelectClasifyNumbers(clasifyNumbers);
    setSelectClasifyValue(value);
  };

  const handleProfile = event => {
    setProfileSelect(event.target.value);
  };

  const handleProject = project => {
    if (project === 'All') {
      setVideosToShow(allVideos);
      setSelectProject('All');
    } else {
      const filterVideos = allVideos.filter(element => element.project === project._id);
      setSelectProject(project);
      setVideosToShow(filterVideos);
    }
  };

  const handleVideoSelected = video => {
    const filteredProfiles = profiles.filter(
      element => profileOps.getVideoId(element) === video._id
    );
    if (!isEmpty(filteredProfiles)) {
      setProfilesToShow(filteredProfiles);
      setProfileSelect(filteredProfiles[0]);
    } else {
      setProfilesToShow([]);
      setProfileSelect({});
    }
    setSelectVideo(video);

    if (newProfileId !== '') setNewProfileId('');
  };

  React.useEffect(() => {
    callToBackEntWine();
  }, []);

  React.useEffect(() => {
    if (!isEmpty(listEntWine)) {
      loadClasifyPointsProfile();
    }
  }, [listEntWine]);

  React.useEffect(() => {
    if (!isEmpty(profiles)) {
      if (selectVideo !== 'none' && newProfileId !== '') {
        const newProfilesToShow = profiles.filter(
          element => profileOps.getVideoId(element) === selectVideo._id
        );
        const newProfile = find(profiles, ['_id', newProfileId]);
        setProfileSelect(newProfile);
        setProfilesToShow(newProfilesToShow);
      }
    }
  }, [profiles]);

  return (
    <>
      <PageHeader>
        <h4>New Profile</h4>
      </PageHeader>
      <br />
      <Box style={{ display: 'flex', flexWrap: 'column' }}>
        <Box
          style={{
            width: '45%',
            marginRight: '2%'
          }}
        >
          {!isEmpty(projectList) && (
            <FormControl fullWidth>
              <InputLabel id="select-project">Proyecto</InputLabel>
              <Select
                labelId="select-project"
                id="select-project"
                label="Proyecto"
                value={selectProject}
                onChange={event => handleProject(event.target.value)}
                size="small"
              >
                <MenuItem value="All">Todos</MenuItem>
                {projectList.map(item => (
                  <MenuItem key={item.name} value={item}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {!isEmpty(videosToShow) && (
            <>
              <FormControl fullWidth style={{ marginTop: '5%' }}>
                <InputLabel id="demo-select-label">Video</InputLabel>
                <Select
                  labelId="demo-select-label"
                  id="demo-select"
                  label="SelectVideo"
                  size="small"
                  value={selectVideo}
                  onChange={event => {
                    handleVideoSelected(event.target.value);
                  }}
                >
                  <MenuItem key={uuid()} value="none">
                    ----------
                  </MenuItem>
                  {map(
                    videosToShow,
                    video =>
                      !isEmpty(video.track) && (
                        <MenuItem key={video.name} value={video}>
                          {video.name}
                        </MenuItem>
                      )
                  )}
                </Select>
              </FormControl>
              <FormControl fullWidth style={{ marginTop: '5%', flexDirection: 'row' }}>
                <TextField
                  id="outlined-required"
                  label="Nombre del perfil"
                  size="small"
                  value={nameProfile}
                  onChange={event => setNameProfile(event.target.value)}
                  style={{ width: '70%' }}
                />
                <TextField
                  id="bufferProfile"
                  size="small"
                  label="Buffer (m)"
                  type="number"
                  value={selectBuffer}
                  inputProps={{
                    min: 0,
                    step: '0.1'
                  }}
                  onChange={event => {
                    setSelectBuffer(event.target.value);
                  }}
                />
              </FormControl>
              {!isEmpty(listEntWine) && !isEmpty(clasifyProfile) ? (
                <>
                  <FormControl fullWidth style={{ marginTop: '5%' }}>
                    <InputLabel id="demo-select-label">Zona Perfil</InputLabel>
                    <Select
                      labelId="demo-select-label"
                      id="demo-select"
                      label="ProfileZone"
                      defaultValue="none"
                      size="small"
                      value={selectEntWine}
                      onChange={event => {
                        setSelectEntWine(event.target.value);
                      }}
                    >
                      <MenuItem key={uuid()} value="none">
                        ----------
                      </MenuItem>
                      {map(listEntWine, entWine => (
                        <MenuItem key={entWine.name} value={entWine}>
                          {entWine.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth style={{ marginTop: '5%' }}>
                    <InputLabel id="demo-multiple-checkbox-label">Clasificación</InputLabel>
                    <Select
                      labelId="demo-multiple-checkbox-label"
                      id="demo-multiple-checkbox"
                      label="ProfileClasify"
                      multiple
                      size="small"
                      input={<OutlinedInput id="select-multiple-chip" />}
                      renderValue={selected => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                          {selected.map(value => (
                            <Chip key={uuid()} label={value} />
                          ))}
                        </Box>
                      )}
                      value={selectClasifyValue}
                      MenuProps={MultipleSelectProps}
                      onChange={event => handleCasifyProfile(event.target.value)}
                    >
                      {map(clasifyProfile, clasify => (
                        <MenuItem key={clasify.name} value={clasify.name}>
                          {clasify.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl style={{ marginTop: '5%', flexDirection: 'row' }}>
                    {!loadProfile ? (
                      <>
                        <Button
                          variant="outlined"
                          color="success"
                          onClick={() => {
                            setLoadProfile(true);
                            setIsProfileExist(false);
                            checkProfileBBDD();
                          }}
                        >
                          Generar perfil
                        </Button>
                        <Button variant="outlined" onClick={() => history.push('/videos/profiles')}>
                          Atrás
                        </Button>
                        {isProfileExist && <Alert severity="info">Ya existe el perfil</Alert>}
                      </>
                    ) : (
                      <Loading />
                    )}
                  </FormControl>
                </>
              ) : (
                <FormControl fullWidth style={{ marginTop: '5%' }}>
                  <Alert severity="info" key={uuid()}>
                    Cargando perfil...
                  </Alert>
                </FormControl>
              )}
            </>
          )}
        </Box>
        <Box
          style={{
            width: '55%'
          }}
        >
          {!isEmpty(videosToShow) && (
            <ViewVideosProfiles
              profiles={profilesToShow}
              newProfileId={newProfileId}
              profileSelect={profileSelect}
              handleProfile={handleProfile}
              match={match}
            />
          )}
        </Box>
      </Box>
    </>
  );
};
NewVideosProfiles.defaultProps = {
  profiles: [],
  match: {},
  history: {}
};
NewVideosProfiles.propTypes = {
  loading: PropTypes.bool.isRequired,
  allVideos: PropTypes.array.isRequired,
  projectList: PropTypes.array.isRequired,
  profiles: PropTypes.array,
  match: PropTypes.object,
  history: PropTypes.object
};

export default withTracker(() => {
  const options = { deleted: { $eq: 'no' } };
  const sortOptions = { sort: { name: 1 } };
  const videosSub = Meteor.isClient && Meteor.subscribe('videos.maps');
  const projectsSub = Meteor.subscribe('projects');
  const profilesSub = Meteor.isClient && Meteor.subscribe('profiles');
  return {
    loading: !videosSub.ready() || !projectsSub.ready() || !profilesSub.ready(),
    allVideos: Videos.find({}, { sort: { name: 1 } }).fetch(),
    projectList: Projects.find(options, sortOptions).fetch(),
    profiles: Profiles.find({}, { sort: { name: 1 } }).fetch()
  };
})(NewVideosProfiles);
